import { useState, useEffect, useRef } from 'react';
import { Auth } from 'aws-amplify';

import { FormattedMessage } from 'react-intl';
import Button from '../../components/Button';

const timeout = 30;

const ResendConfirmation = ({ username }) => {
  const [resent, setResent] = useState(false);
  const [disabled, setDisabled] = useState(0);
  const intervalRef = useRef();

  useEffect(() => {
    if (disabled <= 0) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [disabled]);

  const resetTimer = () => {
    setDisabled(timeout);

    requestAnimationFrame(() => {
      intervalRef.current = setInterval(() => {
        setDisabled((prev) => {
          return prev - 1;
        });
      }, 1000);
    });
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleResend = async () => {
    if (!username) {
      return;
    }

    resetTimer();

    try {
      try {
        await Auth.resendSignUp(username, {});
        console.log('code resent successfully');
      } catch (err) {
        console.log('error resending code: ', err);
      }

      setResent(true);

      setTimeout(() => {
        setResent(false);
      }, 5000);
    } catch (error) {
      console.log('error signing up:', error);
    }
  };

  return (
    <div>
      <div style={{ fontSize: 16, fontWeight: 600 }} className="mb-1">
        <FormattedMessage defaultMessage="Din e-postadress är inte verifierad" />
      </div>
      <div style={{ fontSize: 14 }} className="mb-2">
        <FormattedMessage defaultMessage="Kolla din inkorg eller skräppost om du inte skulle hitta mejlet. Hittar du inget kan du begära ett nytt genom att trycka på knappen nedan." />
      </div>

      <Button
        onClick={handleResend}
        disabled={disabled}
        backgroundColor="whiteColor"
        style={{
          height: 34,
          fontSize: 12,
          marginTop: 4,
        }}
        titleColor="errorColor"
      >
        <FormattedMessage defaultMessage="Skicka nytt verifieringsmejl" />
      </Button>

      {resent && (
        <div style={{ fontSize: 14 }}>
          <FormattedMessage defaultMessage="Ett nytt verifieringsmejl har skickats till dig." />
        </div>
      )}
    </div>
  );
};

export default ResendConfirmation;
